import { useState, useEffect } from 'react';
import type { Ratio, Style, Tone, Toolkit } from '../../../types';
import { fetchRatios, fetchStyles, fetchTones, fetchToolkits } from '../../../services/api';

type Field = 'ratios' | 'styles' | 'tones' | 'toolkits';

interface ReferenceData {
    ratios: Ratio[];
    styles: Style[];
    tones: Tone[];
    toolkits: Toolkit[];
}

export function useReferenceData(fields: Field[]): ReferenceData {
    const [ratios, setRatios] = useState<Ratio[]>([]);
    const [styles, setStyles] = useState<Style[]>([]);
    const [tones, setTones] = useState<Tone[]>([]);
    const [toolkits, setToolkits] = useState<Toolkit[]>([]);

    useEffect(() => {
        const fetches: Promise<void>[] = [];
        if (fields.includes('ratios')) fetches.push(fetchRatios().then(setRatios).catch(console.error));
        if (fields.includes('styles')) fetches.push(fetchStyles().then(setStyles).catch(console.error));
        if (fields.includes('tones')) fetches.push(fetchTones().then(setTones).catch(console.error));
        if (fields.includes('toolkits')) fetches.push(fetchToolkits().then(setToolkits).catch(console.error));
        Promise.all(fetches);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { ratios, styles, tones, toolkits };
}
